import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/startAPetition/pageContext';

export function StartAPetitionErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for StartAPetition page (error: ${error})`);
}
